import { ConvenienceFeeDocuments } from "./ConvenienceFeeDocuments"
export class Payments {
    RequestId: string;
    CustomerId: number;
    PaymentMethod: string;
    OnlinePaymentId: number;
    Application: string;
    Feature: string;
    PaymentAmount: number;
    PaymentDate: string;
    Documents?: ConvenienceFeeDocuments[] = [];
    AccountNumber: number;
}